<!-- <ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>Meeting</li>
</ul> -->
<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Default Meeting Details</strong>
      </span>
      <span style="float:right">
        <a  (click) = "showAddPopUp()">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button" [appHasPermission]="{'Url': '/defaultMeeting/edit?goveva=true&email=', 'method':'put', 'menu': 'DefaultMeeting'}">
            <i class="fa fa-plus"></i>&nbsp;Add Default Meeting Details
          </button>
        </a>
      </span>
    </div>
    
    <!-- <section class="card search-box">
      <div class="card-header" data-toggle="collapse" data-target="#search-div">Modify Search
        <span class="pull-right">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </div>
      <div class="card-block collapse" id="search-div">
        <div class="row">
          <div class="col-lg-12">
            <form (document:click)="c.close();r.close();">
              <div class="row">
                <div class="col-sm-2">
                  <label>Meeting Type :</label>
                  <div class="input-group">
                    <select id="drpmeeting" [(ngModel)]="selectedMeeting" class="form-control" (ngModelChange)="getMeetingFromType()" [ngModelOptions]="{standalone:true}">
                      <option value=null [selected]="true">Select</option>
                      <option *ngFor="let meetingTypeList of meetingType" [ngValue]="meetingTypeList._id">{{meetingTypeList.MeetingType}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-2">
                  <label>Meetings Date:</label>
                  <div class="input-group">
                    <select class=" form-control" [(ngModel)]="meetingsSearch" [ngModelOptions]="{standalone:true}">
                      <option value=null [selected]="true">Select</option>
                      <option *ngFor="let meeting of meetingDateOnSelectedType" [value]="meeting._id">{{meeting.meetingList.MeetingDate | date: "dd-MM-y"}} {{meeting.meetingList.MeetingTime}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <label>Meetings Date Range:</label>
                  <div class="input-group" (click)="$event.stopPropagation()">
                    From:&nbsp;
                    <input class="form-control" [(ngModel)]="meetingsSearchDateFrom" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                      ngbDatepicker #c="ngbDatepicker" (focus)="c.toggle();r.close();" (document:click)="c.close();" [minDate]="minDateForSearchFrom"
                      (ngModelChange)="meetingDateSearchMeeting()" [ngModelOptions]="{standalone: true}">
                    <button class="input-group-addon" (click)="c.toggle();r.close();" type="button">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button> &nbsp;&nbsp; To:&nbsp;
                    <input class="form-control" [(ngModel)]="meetingsSearchDateTo" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker
                      #r="ngbDatepicker" (focus)="r.toggle();c.close();" (document:click)="r.close();" [minDate]="minDateForSearchTo"
                      [ngModelOptions]="{standalone: true}">
                    <button class="input-group-addon" (click)="r.toggle();c.close();" type="button">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button>
                  </div>
                </div>
                <div class="col-sm-2">
                  <label>&nbsp;&nbsp;&nbsp;</label>
                  <div class="input-group">
                    <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)=" searchData(selectedMeeting);">
                      <i class="fa fa-search"></i>Search</button>
                    &nbsp;&nbsp;&nbsp;
                    <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2" (click)="clear()">
                      <i class="fa fa-refresh"></i>Clear</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section> -->
  
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap stripe"
                   style="cursor: pointer;">
                  <thead>
                    <tr>
                      <th>Meeting Type</th>
                      <th class="group-list-action"><span >Action</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of defaultMeetingMasterData;">
                      <td tabindex="1">{{data.MeetingTypeName }}</td>
                      <td class="group-list-action">
                        <button type="button" class="btn-sm btn btn-warning" (click)="editDefaultMeetingMaster(data._id)" [appHasPermission]="{'Url': '/defaultMeeting/edit?goveva=true&email=', 'method':'put', 'menu': 'DefaultMeeting'}">
                          <span class="fa fa-pencil"></span>
                        </button>&nbsp;&nbsp;&nbsp;
                        <button type="button" class="btn-sm btn btn-danger" (click)="deleteConfirmation(data._id)" [appHasPermission]="{'Url': '/defaultMeeting/edit?goveva=true&email=', 'method':'put', 'menu': 'DefaultMeeting'}">
                          <span class="icmn-bin"></span>
                        </button>
                      </td>
                    </tr>
  
                    <tr *ngIf="!dataAvailable"> 
                      <td style="text-align: center;">No Data Available</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
      aria-labelledby="" aria-hidden="true" style="top: 50px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabelForDeletion">
              <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                Are you sure you want to delete default meeting details?
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger" (click)="deleteDefaultMeetingMaster()" data-dismiss="modal">
              <i class="fa fa-check"></i>&nbsp;Yes</button>
            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
              <i class="fa fa-times"></i>&nbsp;No</button>
          </div>
        </div>
      </div>
    </div>
   
  </section>
   <app-alert></app-alert>